import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  group: null,
  groups: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
